(() => {
  if (window.mcsPerformanceReady) return;
  window.mcsPerformanceReady = true;
  let widgetTimer;
  let widgetAttempts = 0;
  let widgetsPending = false;

  const initializeWidgets = () => {
    clearTimeout(widgetTimer);
    if (!widgetsPending) return;
    if (typeof window.yotpoWidgetsContainer?.initWidgets === 'function') {
      widgetsPending = false;
      widgetAttempts = 0;
      window.yotpoWidgetsContainer.initWidgets();
    } else if (++widgetAttempts <= 30) {
      widgetTimer = setTimeout(initializeWidgets, 500);
    }
  };

  class LazyWidget extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-loaded')) return;
      // Collection ratings initialize together, including after filtering/paging.
      // Initializing every newly visible row makes Yotpo rebuild earlier rows.
      if (this.hasAttribute('data-eager')) {
        this.activate();
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some(entry => entry.isIntersecting)) this.activate();
      }, { rootMargin: '200px 0px' });
      this.observer.observe(this);
    }
    activate() {
      const template = this.querySelector('template[data-mcs-widget]');
      if (!template) return;
      this.observer?.disconnect();
      this.setAttribute('data-loaded', '');
      this.append(template.content.cloneNode(true));
      template.remove();
      widgetsPending = true;
      widgetAttempts = 0;
      clearTimeout(widgetTimer);
      widgetTimer = setTimeout(initializeWidgets, 100);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  }

  class LazyImage extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-loaded')) return;
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some(entry => entry.isIntersecting)) this.activate();
      }, { rootMargin: '250px' });
      this.observer.observe(this);
    }
    activate() {
      const template = this.querySelector('template[data-mcs-image]');
      if (!template) return;
      this.observer?.disconnect();
      this.setAttribute('data-loaded', '');
      this.append(template.content.cloneNode(true));
      template.remove();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  }

  const hydrateDialog = dialog => {
    if (!dialog?.matches('x-popover')) return;
    const template = dialog.querySelector(':scope > template[data-mcs-dialog-content]');
    if (!template) return;
    dialog.append(template.content.cloneNode(true));
    template.remove();
  };
  const prepareControl = event => {
    const control = event.target.closest?.('[aria-controls]');
    if (control) hydrateDialog(document.getElementById(control.getAttribute('aria-controls')));
  };
  document.addEventListener('click', prepareControl, true);
  document.addEventListener('focusin', prepareControl, true);
  document.addEventListener('pointerover', prepareControl, { capture: true, passive: true });

  document.addEventListener('click', event => {
    const summary = event.target.closest?.('.yotpo-sr-bottom-line-button');
    if (!summary || summary.closest('mcs-lazy-widget[data-kind="rating"]')) return;
    const reviews = document.querySelector('mcs-lazy-widget[data-kind="reviews"]');
    if (!reviews || reviews.hasAttribute('data-loaded')) return;
    reviews.activate();
    // The vendor's scroll target is created when its deferred widget renders.
    // Scroll to the reserved section immediately on this first explicit visit.
    setTimeout(() => reviews.scrollIntoView({ behavior: 'smooth', block: 'start' }), 0);
  }, true);

  if (!customElements.get('mcs-lazy-widget')) customElements.define('mcs-lazy-widget', LazyWidget);
  if (!customElements.get('mcs-lazy-image')) customElements.define('mcs-lazy-image', LazyImage);
})();
